import React from "react";
import ReactDOM from "react-dom/client";
import RewardCalculator from "../components/reward_calculator";

document.addEventListener("DOMContentLoaded", () => {
  const mountPoint = document.getElementById("reward-calculator-mount-point");

  if (mountPoint) {
    const {
      backUrl,
      printMode: printModeString,
      hideTreatmentCategorySwitcher: hideTreatmentCategorySwitcherString,
      hideModeSwitcher: hideModeSwitcherString,
      hideAutoGrowSwitcher: hideAutoGrowSwitcherString,
      defaultTreatmentCategory,
      defaultCalculatorMode,
      defaultAutoGrowMode,
      defaultInitialBalance: defaultInitialBalanceString,
      defaultGoalBalance: defaultGoalBalanceString,
      defaultBalanceDurationInMonths: defaultBalanceDurationInMonthsString,
      defaultOngoingDepositsAmount: defaultOngoingDepositsAmountString,
      defaultOngoingDepositsFrequency,
      defaultOngoingClinicPurchasesAmount:
        defaultOngoingClinicPurchasesAmountString,
      defaultOngoingClinicPurchasesFrequency,
      defaultRewardRate: defaultRewardRateString,
      defaultTopUpAmountForInitialBalance:
        defaultTopUpAmountForInitialBalanceString,
      defaultTopUpAmountForIndividualOngoingDeposit:
        defaultTopUpAmountForIndividualOngoingDepositString,
      defaultTimeToHitGoalInMonths: defaultTimeToHitGoalInMonthsString,
    } = mountPoint.dataset;

    let printMode;
    if (printModeString) {
      printMode = printModeString === "true";
    }

    let hideTreatmentCategorySwitcher;
    if (hideTreatmentCategorySwitcherString) {
      hideTreatmentCategorySwitcher =
        hideTreatmentCategorySwitcherString === "true";
    }

    let hideModeSwitcher;
    if (hideModeSwitcherString) {
      hideModeSwitcher = hideModeSwitcherString === "true";
    }

    let hideAutoGrowSwitcher;
    if (hideAutoGrowSwitcherString) {
      hideAutoGrowSwitcher = hideAutoGrowSwitcherString === "true";
    }

    let defaultInitialBalance;
    if (defaultInitialBalanceString) {
      defaultInitialBalance = parseFloat(defaultInitialBalanceString);
    }

    let defaultGoalBalance;
    if (defaultGoalBalanceString) {
      defaultGoalBalance = parseFloat(defaultGoalBalanceString);
    }

    let defaultBalanceDurationInMonths;
    if (defaultBalanceDurationInMonthsString) {
      defaultBalanceDurationInMonths = parseInt(
        defaultBalanceDurationInMonthsString
      );
    }

    let defaultOngoingDepositsAmount;
    if (defaultOngoingDepositsAmountString) {
      defaultOngoingDepositsAmount = parseFloat(
        defaultOngoingDepositsAmountString
      );
    }

    let defaultOngoingClinicPurchasesAmount;
    if (defaultOngoingClinicPurchasesAmountString) {
      defaultOngoingClinicPurchasesAmount = parseFloat(
        defaultOngoingClinicPurchasesAmountString
      );
    }

    let defaultRewardRate;
    if (defaultRewardRateString) {
      defaultRewardRate = parseFloat(defaultRewardRateString);
    }

    let defaultTopUpAmountForInitialBalance;
    if (defaultTopUpAmountForInitialBalanceString) {
      defaultTopUpAmountForInitialBalance = parseFloat(
        defaultTopUpAmountForInitialBalanceString
      );
    }

    let defaultTopUpAmountForIndividualOngoingDeposit;
    if (defaultTopUpAmountForIndividualOngoingDepositString) {
      defaultTopUpAmountForIndividualOngoingDeposit = parseFloat(
        defaultTopUpAmountForIndividualOngoingDepositString
      );
    }

    let defaultTimeToHitGoalInMonths;
    if (defaultTimeToHitGoalInMonthsString) {
      defaultTimeToHitGoalInMonths = parseInt(
        defaultTimeToHitGoalInMonthsString
      );
    }

    ReactDOM.createRoot(mountPoint).render(
      <RewardCalculator
        backUrl={backUrl}
        printMode={printMode}
        hideTreatmentCategorySwitcher={hideTreatmentCategorySwitcher}
        hideModeSwitcher={hideModeSwitcher}
        hideAutoGrowSwitcher={hideAutoGrowSwitcher}
        defaultTreatmentCategory={defaultTreatmentCategory}
        defaultCalculatorMode={defaultCalculatorMode}
        defaultAutoGrowMode={defaultAutoGrowMode}
        defaultInitialBalance={defaultInitialBalance}
        defaultGoalBalance={defaultGoalBalance}
        defaultBalanceDurationInMonths={defaultBalanceDurationInMonths}
        defaultOngoingDepositsAmount={defaultOngoingDepositsAmount}
        defaultOngoingDepositsFrequency={defaultOngoingDepositsFrequency}
        defaultOngoingClinicPurchasesAmount={
          defaultOngoingClinicPurchasesAmount
        }
        defaultOngoingClinicPurchasesFrequency={
          defaultOngoingClinicPurchasesFrequency
        }
        defaultRewardRate={defaultRewardRate}
        defaultTopUpAmountForInitialBalance={
          defaultTopUpAmountForInitialBalance
        }
        defaultTopUpAmountForIndividualOngoingDeposit={
          defaultTopUpAmountForIndividualOngoingDeposit
        }
        defaultTimeToHitGoalInMonths={defaultTimeToHitGoalInMonths}
      />
    );
  }
});
